/* import __COLOCATED_TEMPLATE__ from './icon-radio.hbs'; */
import SvgIcon from '@square/glass-ui/components/svg/svg-icon';
export default SvgIcon.extend({
  classNames: ['svg-icon--radio'],
  viewBox: '0 0 16 16',
  width: 16,
  height: 16
});